import idb from "@/plugins/indexdb.js";
import UpperLimbRepo from "@/repositories/products/upperLimbRepository";

import upperLimbDefaultForm from "./forms/upperLimb";

export default {
  namespaced: true,

  state: {
    upperLimb: upperLimbDefaultForm
  },

  mutations: {
    // Set upper limb
    SET_UPPER_LIMB(state, payload) {
      state.upperLimb = Object.assign({}, state.upperLimb, payload);
    },

    // Reset upper limb object
    RESET_UPPER_LIMB(state) {
      state.upperLimb = upperLimbDefaultForm;
    }
  },
  actions: {
    /**
     * Get upper limb product by uuid
     *
     * @param {String} upper_limb_uuid Upper limb uuid
     */
    async get({ commit }, upper_limb_uuid) {
      try {
        const { data } = await UpperLimbRepo.get(upper_limb_uuid);
        commit("SET_UPPER_LIMB", data);
        return data;
      } catch (error) {
        throw error;
      }
    },

    // Create a new upper limb
    async createUpperLimb(context, payload) {
      try {
        const { data } = await UpperLimbRepo.createUpperLimb(payload);
        return data;
      } catch (error) {
        throw error;
      }
    },

    /**
     * Local part
     */

    /**
     * Get upper limb product from IndexedDB
     *
     * @param {String} upper_limb_uuid Upper limb uuid
     */
    async getFromLocal({ commit }, upper_limb_uuid) {
      const upperLimb = await idb.db.upper_limb.get(upper_limb_uuid);

      // If not found return null
      if (!upperLimb) return null;

      commit("SET_UPPER_LIMB", upperLimb);

      return upperLimb;
    },

    // Reset upper limb
    resetProduct({ commit }) {
      commit("RESET_UPPER_LIMB");
    }
  }
};
